import { greeting } from '../../lib/workflow';

export const HomeHeader = ({ emoji, name, subtitle, children, testId = 'home-header' }) => {
  const first = (name || 'there').split(/[\s(]/)[0];
  const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
  return (
    <div className="wf-card wf-rise relative overflow-hidden p-6 sm:p-8 bg-gradient-to-br from-[#FFF8EC] via-white to-[#FDF0EC]" data-testid={testId}>
      <div className="pointer-events-none absolute -right-4 -top-8 text-[140px] opacity-[0.08] select-none" aria-hidden>{emoji}</div>
      <p className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#C85A32]">{today}</p>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#2D2623] mt-2">
        {greeting()}, {first} <span className="wf-float" aria-hidden>{emoji}</span>
      </h1>
      {subtitle && <p className="text-sm text-[#6E635B] mt-2 max-w-2xl">{subtitle}</p>}
      {children}
    </div>
  );
};
